import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserDccsService } from '../services/user-dccs/user-dccs.service';

// Adds the current DCC as a `dcc` header on every outgoing API request so the
// backend scopes data to the user's active DCC, regardless of feature.
export function dccInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  // Static assets never need the DCC (mirrors environmentInterceptor).
  if (req.url.includes('/assets/')) return next(req);

  const dcc = inject(UserDccsService).getUserAssignedDcc();

  // No DCC selected yet → send nothing.
  if (!dcc) return next(req);

  // Respect a dcc header a caller already set explicitly.
  if (req.headers.has('dcc')) return next(req);

  return next(req.clone({ headers: req.headers.set('dcc', dcc) }));
}
